import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface DeleteCommentResponse {
  id: string;
}

interface UseDeleteCommentParams {
  commentId: string;
}

export const useDeleteComment = (matterId: string, subsetId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<DeleteCommentResponse, Error, UseDeleteCommentParams>(
    async ({ commentId }: UseDeleteCommentParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/comments/${commentId}`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to delete comment');
      }

      return response.json();
    },
    {
      onSuccess: () => {
        if (subsetId) {
          queryClient.invalidateQueries({ queryKey: [QueryEntity.CaseFacts, { caseId: subsetId }] });
          queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetFacts, { subsetId }] });
        }
        queryClient.invalidateQueries({ queryKey: [QueryEntity.ChronologyFacts] });
        toast.success('Comment deleted successfully');
      },
      onError: (error) => {
        console.error('Error deleting comment:', error);
        toast.error('Failed to delete comment. Please try again.');
      },
    },
  );
};
